import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MotionConfig } from 'motion/react'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { queryClient } from './queries/queryClient'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* reducedMotion="user" makes Motion drop transform and layout animations
        for anyone who asks for reduced motion, app-wide. Components no longer
        each branch on useReducedMotion(); opacity fades still run. */}
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          {/* AuthProvider clears the query cache on a detected user-id
              change by importing the queryClient singleton directly (see
              AuthContext.jsx), not via useQueryClient(), so it doesn't
              structurally need to be inside QueryClientProvider — it's
              nested here because every page below it also needs the
              provider to call useQuery/useMutation. */}
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </MotionConfig>
    </QueryClientProvider>
  </React.StrictMode>
)
